import getStore from "src/utils/redux/store";
import { forwardUpid, pushReroll, setParam } from "./utils";
import { OffersParams } from "@pageDefinitions/goto/offers";
import { postMakeEligible } from "src/funnels/insurance-reimbursement/apiRequests";
import { setNoomSessionStorage } from "src/utils/noomSessionStorage";
import { SessionStorageKey } from "src/utils/constants";
import { createForwardParams, getSearchQuery } from "src/utils/urlParams";

import { reroll } from "../components/PageSetRouter";
import { isTelehealth } from "src/utils/userSegment/features";
import { getSchedulerFlowForConsultType } from "src/components/refactored-survey/question-sets/insurance-survey-questions/utils/insuranceConstants";
import { getSessionState } from "src/pageDefinitions/session";

function telehealthPath(
  pathname: string,
  additionalQueryParams?: Record<string, string | number | boolean>
) {
  const store = getStore();
  const state = store.getState();
  const { userData } = state;

  forwardUpid(store);

  const queryParams = createForwardParams();
  setParam(queryParams, "userId", userData.user_id);

  // eslint-disable-next-line no-restricted-syntax,guard-for-in
  for (const key in additionalQueryParams) {
    if (additionalQueryParams[key]) {
      setParam(queryParams, key, additionalQueryParams[key]);
    }
  }

  return `/telehealth${pathname}${getSearchQuery(queryParams)}`;
}
const telehealthRoot = (
  additionalQueryParams?: Record<string, string | number | boolean>
) => {
  return telehealthPath("/", additionalQueryParams);
};

export default {
  async insurance(isTelehealthBuyflow: boolean) {
    const state = getStore().getState();

    if (isTelehealthBuyflow) {
      setNoomSessionStorage(SessionStorageKey.isTelehealthBuyflow, true);
      await postMakeEligible(state.userData.user_id);
    } else {
      setNoomSessionStorage(SessionStorageKey.isTelehealthBuyflow, false);
    }

    const additionalQueryParams = {
      noomPlanId: state.recommendedPlan.noom_plan_id,
    };
    reroll(`${telehealthRoot(additionalQueryParams)}#/insurance`);
  },

  patientIntake(params?: OffersParams) {
    const additionalQueryParams = params
      ? {
          claimedByEmail: params.claimedByEmail,
          enrollmentResult: params.enrollmentResult,
          userId: params.userId,
        }
      : {};
    pushReroll(
      `${telehealthRoot(additionalQueryParams)}#/patientIntake`,
      isTelehealth
    );
  },

  telehealthLanding() {
    reroll(`${telehealthRoot()}#/landing`);
  },

  telehealthSchedule(schedulerFlow?: string) {
    let path = "/schedule";
    const browserSession = getSessionState("browser");
    if (schedulerFlow) {
      path += `/${schedulerFlow}`;
    } else if (browserSession.consultTypeToSchedule) {
      path += `/${getSchedulerFlowForConsultType(
        browserSession.consultTypeToSchedule
      )}`;
    }
    reroll(telehealthPath(path));
  },

  telehealthReschedule(schedulerFlow?: string) {
    let path = "/reschedule";
    if (schedulerFlow) {
      path += `/${schedulerFlow}`;
    }
    reroll(telehealthPath(path));
  },

  orderScale() {
    pushReroll(`${telehealthRoot()}#/orderScale`, isTelehealth);
  },
};
